import React from "react";
import "../CSS/TopbarTenagaKesehatan.css";
import { FaBell, FaUserCircle } from "react-icons/fa";

function TopBarChatPasien() {
  return (
    <div className="topbar">

      <div className="topbar-left">
        <h2 className="page-title">Message</h2>
      </div>


      <div className="user-info">
        <FaBell className="icon" />
        <div className="user-name">
          <p className="name">Megumi</p>
          <p className="role">Dokter</p>
        </div>
        <FaUserCircle className="profile-icon" />
      </div>
    </div>
  );
}

export default TopBarChatPasien;
